/** Diameter of the indicator inside a loading button. */
export const DEFAULT_LOADER_SIZE = 16;

/** Fraction of the loader's diameter used for its ring thickness. */
export const LOADER_BORDER_RATIO = 0.125;
